import { useEffect, useState } from 'react';

const useCurrentPathMatch = (paths: string[]) => {
    const [isMatch, setIsMatch] = useState(false);

    useEffect(() => {
        setIsMatch(paths.some((path) => decodeURIComponent(window.location.pathname).includes(path)));
    }, [paths, window.location.pathname]);

    return isMatch;
};

export default useCurrentPathMatch;
